<template>
  <With_Header_Modal_Template title="Аренда рабочего места"
                              :content-style="`max-height: calc(100vh - ${ mobile ? 170 : 255}px); overflow: auto;`">
    <preload-content :loading="loading" :min-height="`max-height: calc(100vh - ${mobile ? 170 : 255}px)`">
      <template v-if="!loading">
        <div class="top">
          <row margin="0 -10px">
            <grid-item
                mb="20px"
                padding="0 10px"
                xl="2d4"
                md="6"
                xs="12"
                v-for="(zone, index) in zones"
                :key="index"
            >
              <Rent_Chose_Role
                  :title="zone.name"
                  :desc="zone.structure"
                  :isActive="zone.isActive"
                  @chose="choseZone(index)"
              />
            </grid-item>
            <div v-if="!zones.length">
              <h3>Список зон коворкинга пуст</h3>
            </div>
          </row>
        </div>
        <div class="week">
          <WeekGrid
              :blockRoleSelect="blockRoleSelect"
              :chosen-zone="chosenZone"
              :zones="zones"
              :coworking="coworking"
              :events="events"
              :newEvents="newEvents"
              @mobile="mobile = $event"
              @submit="saveEvent"
              @pushEvent="addEvent"
              @delete="removeEvent"
              @changeTime="changeTime"
              @blockRoles="blockRoles"
              @choseCircle="choseCircle"
              @removeCircle="removeCircle"
              @changedWeek="changedWeek"
          />
        </div>
        <div class="coworkings">
          <div class="coworkings__item" v-for="b in coworkings" :key="b.id">
            <div class="circle" :style="{backgroundColor: b.color}"></div>
            <span>{{ b.name }}</span>
          </div>
        </div>
      </template>
    </preload-content>
    <template v-slot:footer>
      <button @click="confirm" :disabled="!canConfirm" :style="{width: mobile ? '100&' : ''}">К оформлению заказа</button>
    </template>
  </With_Header_Modal_Template>
</template>

<script>
import PreloadContent from '@/components/ui/preload-content';
import With_Header_Modal_Template from '@/components/Modals/ModalsTemplate/With_Header_Modal_Template'
import Row from '@/components/grid/Row'
import GridItem from '@/components/grid/GridItem'
import Rent_Chose_Role from '@/components/Modals/ModalsComponents/Rent_Chose_Role'
import WeekGrid from '@/components/Calendar/WeekGrid'
import {mapMutations} from 'vuex'

export default {
  name: "Rent",
  components: {WeekGrid, Rent_Chose_Role, Row, With_Header_Modal_Template, GridItem, PreloadContent},
  mounted() {
    this.$eventHub.$on('coworking.rent.set', (data) => {
      this.coworking = data;
      this.zones = this.coworking.zones.map(val => {
        val.isActive = false;
        return val;
      });
      if (!this.zones.length) this.$toast.error('К сожалению, аренда невозможна! Список зон коворкинга пуст');
    });
    if (window.innerWidth < 785) {
      this.mobile = true;
    }
  },
  data() {
    return {
      mobile: false,
      coworking: null,
      period: {start: null, end: null},
      zones: null,
      chosenZone: null,
      // events
      newEvents: [],
      events: [],
      // places
      placesBackground: require('../../../assets/images/coworkings/background.svg'),
      blockRoleSelect: false,
      confirming: false,
    }
  },
  computed: {
    newSavedEvents() {
      return this.newEvents.filter(el => el.isSaved)
    },
    loading() {
      return !this.zones || !this.coworking || this.confirming;
    },
    canConfirm() {
      return !!this.newEvents.length && !this.confirming;
    },
    coworkings() {
      if (!this.events || !this.events.length) return [];
      let coworkings = Object.assign([], this.events).map((val) => val.coworking);
      coworkings.push(this.coworking);
      return this._.uniqBy(coworkings, (val) => {
        if (val) return val.id;
      }).filter((val) => val);
    },
  },
  methods: {
    ...mapMutations(['openModal', 'setModalData']),
    changedWeek(start, end) {
      this.period = {start, end};
    },
    loadRents(start, end) {
      this.$api.master.rent.list({start, end}).then(({data}) => this.events = data);
    },
    choseZone(index) {
      this.zones = this.zones.map((zone, key) => {
        zone.isActive = index === key && this.zones[index] !== this.chosenZone;
        if (zone.isActive) this.chosenZone = zone;
        return zone;
      });
      if (!this.zones.filter(val => val.isActive).length) this.chosenZone = null;
    },
    addEvent(evt) {
      this.newEvents.push(evt);
      this.events.push(evt);
    },
    removeEvent(id) {
      this.blockRoleSelect = false
      this.newEvents = this.newEvents.filter(evt => id !== evt.id)
      this.events = this.events.filter(evt => id !== evt.id)
    },
    changeTime(type, value, id) {
      this.events.map(evt => {
        if (id === evt.id) {
          const firstpart = evt[type].split('T')[0]
          evt[type] = `${firstpart}T${value}+03:00`
        }
        return evt
      })
      this.newEvents.map(evt => {
        if (id === evt.id) {
          const firstpart = evt[type].split('T')[0]
          evt[type] = `${firstpart}T${value}+03:00`
        }
        return evt
      })
    },
    blockRoles(v) {
      this.blockRoleSelect = v
    },
    choseCircle(v, id) {
      this.newEvents = this.newEvents.map(evt => {
        if (evt.id === id) {
          evt.workplaces.push(v)
        }
        return evt
      })
    },
    removeCircle(circleId, evtId) {
      this.newEvents = this.newEvents.map(evt => {
        if (evt.id === evtId) {
          evt.workplaces = evt.workplaces.filter(place => place !== circleId)
        }
        return evt
      })
    },
    saveEvent(id) {
      this.newEvents = this.newEvents.map(el => {
        if (el.id === id) el.isSaved = true;
        return el;
      });
    },
    confirm() {
      this.confirming = true;
      this.$api.master.rent.create(this.newSavedEvents.map((rent) => {
        return {
          coworking_id: rent.coworkingId,
          start_at: this.$moment(rent.start).format('YYYY-MM-DD HH:mm:ss'),
          end_at: this.$moment(rent.end).format('YYYY-MM-DD HH:mm:ss'),
          zone_id: rent.zoneId,
          workplaces: rent.workplaces
        };
      })).then(({data}) => {
        this.$toast.success('Забронировано! Перенаправляем на оплату');
        this.openModal('rent_checkout');
        this.setModalData({data, redirect: {name: 'master.cabinet.notifications'}});
      }).catch(({response}) => {
        if (response.data.exception && response.data.message) {
          this.newEvents = [];
          this.$toast.error(response.data.message);
          this.loadRents(this.period.start, this.period.end);
        }
        if (response.data.errors && response.data.errors[Object.keys(response.data.errors)]) this.$toast.error(response.data.errors[Object.keys(response.data.errors)][0]);
      }).finally(() => this.confirming = false);
    }
  },
  watch: {
    'period.start'(to) {
      this.period.start = to;
      this.loadRents(this.period.start.format('YYYY-MM-DD HH:mm:ss'), this.period.end.format('YYYY-MM-DD HH:mm:ss'));
    },
  },
  beforeDestroy() {
    this.$eventHub.$off('coworking.rent.set');
  },
}
</script>

<style scoped lang="scss">
.top {
  padding: 30px;
  background-color: #FAFAFA;
}

.coworkings {
  display: flex;
  flex-wrap: wrap;
  padding: 30px 140px;

  &__item {
    display: flex;
    align-items: center;
    margin-right: 20px;

    .circle {
      width: 15px;
      height: 15px;
      border-radius: 50%;
      margin-right: 5px;
    }
  }
}

@media(max-width: 785px) {
  .coworkings {
    padding: 0 20px 20px 20px;

    &__item {
      margin-bottom: 10px;
    }
  }
}
</style>
